export function logMessage (s) {
}
